var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.error ? '' : 'hidden', 'error'],attrs:{"cy-data":"error"},on:{"click":_vm.deleteError}},[_vm._v("\n  "+_vm._s(_vm.error)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }